import React, { Component, Fragment } from 'react';
import StarredMessages from '../Starred/StarredMessages';
import SDK from '../../SDK';
import { getTranslateTargetLanguage, setLocalWebsettings } from '../../../Helpers/Utility';
import { REACT_APP_GOOGLE_TRANSLATE_API_KEY } from '../../processENV';
import { Store } from '../../../store';
import { transLateLanguageAction } from '../../../Actions/TranslateAction';
import About from './About';
import Blocked from './BlockedContacts';
import Notification from './Notifications';
import './Setting.scss';
import { SettingOptions, SettingsHeader } from './Settings';
import Archive from './ArchivedChat/index';
import DeleteMyAccount from './DeleteMyAccount';
import PropTypes from 'prop-types';
import Chats from './Chats';
import PrivacySettings from './PrivacySettings';

let optionsArray = [
    { label: 'Archived Settings', image: 'Archived' },
    { label: 'Chats', image: 'chat' },
    { label: 'Notifications', image: 'notification' },
    { label: 'Starred Messages', image: 'star' },
    { label: 'Privacy', image: 'Privacy' },
    { label: 'Terms & Policies', image: 'about' },
    { label: 'Delete My Account', image: 'delete' },
];
export default class Setting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parrentView: true,
            activeTab: null,
            setLaunguage: 'English',
        };
    }

    handleSettings = (label = '') => {
        this.setState({
            parrentView: false,
            activeTab: label,
        });
    };
    getLanguages = async () => {
        try {
            const result = await SDK.getTranslateLanguages(REACT_APP_GOOGLE_TRANSLATE_API_KEY);
            const { data: { languages = [] } = {}, statusCode = 0 } = result || {};
            if (statusCode === 200) {
                Store.dispatch(transLateLanguageAction(languages));
            }
        } catch (error) {}
    };

    handleBackToSetting = _e => {
        this.setState({
            parrentView: true,
        });
    };

    setSelectedLaun = () => {
        const globalData = Store.getState();
        const {
            TranslateLanguage: {
                translateLanguages: { translateLanguages = [] },
            },
        } = globalData || {};
        const langIndex = translateLanguages?.findIndex(i => i.language === getTranslateTargetLanguage());
        const langSelected = translateLanguages[langIndex]?.name;
        return langSelected;
    };

    componentDidUpdate = () => {
        this.setSelectedLaun();
        getTranslateTargetLanguage() === '' && setLocalWebsettings('translateLang', 'en');
    };

    componentDidMount = () => {
        this.getLanguages();
    };

    render() {
        const { handleBackFromSetting, featureStateData = {}, handleShowCallScreen } = this.props;
        const { isStarMessageEnabled = false, isBlockEnabled = false } = featureStateData;
        if (!isStarMessageEnabled && !isBlockEnabled) {
            const filteredArray = optionsArray.filter(
                option => option.label !== 'Starred' && option.label !== 'Blocked',
            );
            optionsArray = filteredArray;
        } else if (!isStarMessageEnabled) {
            const filteredArray = optionsArray.filter(option => option.label !== 'Starred');
            optionsArray = filteredArray;
        } else if (!isBlockEnabled) {
            const filteredArray = optionsArray.filter(option => option.label !== 'Blocked');
            optionsArray = filteredArray;
        }
        const { parrentView, activeTab } = this.state;
        return (
            <Fragment>
                {parrentView && (
                    <div className="setting-container">
                        <div>
                            <div className="settinglist">
                                <SettingsHeader
                                    handleBackFromSetting={handleBackFromSetting}
                                    label={'Settings'}
                                    parrentView={parrentView}
                                />
                                <ul className="setting-list-ul">
                                    {optionsArray.map(options => {
                                        const { label, image } = options;
                                        return (
                                            <SettingOptions
                                                key={image}
                                                handleOptions={this.handleSettings}
                                                label={label}
                                                image={image}
                                            />
                                        );
                                    })}
                                    <SettingOptions
                                        handleOptions={this.props.logoutStatus}
                                        enableRightArrow={true}
                                        label={'Logout'}
                                        image={'logout'}
                                    />
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
                {!parrentView && (
                    <Fragment>
                        {activeTab === 'Archived' && <Archive handleBackToSetting={this.handleBackToSetting} />}
                        {activeTab === 'Privacy' && <PrivacySettings handleBackToSetting={this.handleBackToSetting} />}

                        {/* {activeTab === 'chat' &&
                            <Chat
                                setSelectedLaun={(this.setSelectedLaun() !== "") ? this.setSelectedLaun() : "English"}
                                handleBackToSetting={this.handleBackToSetting}
                                featureStateData={featureStateData}
                                 />} */}
                        {activeTab === 'chat' && <Chats handleBackToSetting={this.handleBackToSetting} />}
                        {activeTab === 'notification' && (
                            <Notification handleBackToSetting={this.handleBackToSetting} />
                        )}
                        {activeTab === 'star' && (
                            <StarredMessages
                                handleBackToSetting={this.handleBackToSetting}
                                featureStateData={featureStateData}
                                handleShowCallScreen={handleShowCallScreen}
                            />
                        )}
                        {activeTab === 'blocked' && <Blocked handleBackToSetting={this.handleBackToSetting} />}
                        {activeTab === 'about' && <About handleBackToSetting={this.handleBackToSetting} />}
                        {activeTab === 'delete' && <DeleteMyAccount handleBackToSetting={this.handleBackToSetting} />}
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

Setting.propTypes = {
    handleBackFromSetting: PropTypes.func,
    logoutStatus: PropTypes.func,
    featureStateData: PropTypes.object,
    handleShowCallScreen: PropTypes.func,
};
